import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "store" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "tabs header-content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = {
  key: 0,
  class: "overflow-auto hidden-scrollbar header-content"
}
const _hoisted_7 = { class: "d-flex flex-row" }

import {reactive} from "@vue/reactivity";
import BannerDTO from "@/models/BannerDTO";
import {computed, onMounted} from "vue";
import {api} from "@/service/APIClient";
import Welcome from "@/components/banners/Welcome.vue";
import CoinsStore from "@/components/store/CoinsStore.vue";
import {PurchasableItemContentType} from "@/models/enum/PurchasableItemContentType";
import LootboxesStore from "@/components/store/LootboxesStore.vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'Store',
  setup(__props) {

const route = useRoute()
const resolveTab = (): PurchasableItemContentType => {
  switch (route.params.tab) {
    case 'lootboxes':
      return PurchasableItemContentType.LOOT_BOX;
    default:
      return PurchasableItemContentType.COINS;
  }
}
const state = reactive({
  banners: [] as BannerDTO[],
  page: resolveTab(),
  items: [] as StoreItemDTO[]
});

const coins = computed(() => {
  return state.items.filter(item => item.type === PurchasableItemContentType.COINS)
})

const lootBoxed = computed(() => {
  return state.items.filter(item => item.type === PurchasableItemContentType.LOOT_BOX)
})

onMounted(async () => {
  [state.banners, state.items] = await Promise.all([
    api.call.banners.placement('store'),
    api.call.store.items(),
  ])
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('store')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(PurchasableItemContentType).COINS, _unref(PurchasableItemContentType).LOOT_BOX], (type) => {
          return (_openBlock(), _createElementBlock("button", {
            key: type,
            type: "button",
            onClick: ($event: any) => (_unref(state).page = type),
            class: _normalizeClass(["btn btn-tab", [_unref(state).page === type ? 'btn-primary' : '']])
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`store_tabs.${type}`)), 1)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ]),
    (_unref(state).banners.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).banners, (banner) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: banner.name
              }, [
                (banner.name ==='welcome')
                  ? (_openBlock(), _createBlock(Welcome, {
                      key: 0,
                      config: banner.config
                    }, null, 8, ["config"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(state).page === _unref(PurchasableItemContentType).COINS)
      ? (_openBlock(), _createBlock(CoinsStore, {
          key: 1,
          coins: coins.value
        }, null, 8, ["coins"]))
      : _createCommentVNode("", true),
    (_unref(state).page === _unref(PurchasableItemContentType).LOOT_BOX)
      ? (_openBlock(), _createBlock(LootboxesStore, {
          key: 2,
          lootBoxes: lootBoxed.value
        }, null, 8, ["lootBoxes"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})